export default __webpack_public_path__ + "static/media/TexasTrue.14522203.png";